<div class="seller-page">
  <h1>Mes offres entretien ({{(myCars$ | async)!.length}})</h1>
  <div class="buttons-section">
    <button mat-button (click)="openCarEditDialog()" class="cta-button-buy"><mat-icon>add</mat-icon>Ajouter une prestation</button>
  </div>

  @if (((myCars$ | async) == undefined ) || (myCars$ | async)!.length === 0 ) {
    <h6>
      <br />
      Aucun véhicule dans votre parc
    </h6>
  }

  <app-keep-offers
    [objectSource]="objectSource"
    [businessLine]="businessLine"
    [enableNew]="false">
  </app-keep-offers>

  <!--
  <div class="cars-section" *ngIf="((myCars$ | async) != undefined )">
    <div *ngFor="let car of (myCars$ | async)!; index as i" id="{{car.offerId}}" class="car-section">

      <app-keep-offers
        [objectSource]="objectSource"
        [businessLine]="businessLine"
        [enableNew]="false">
      </app-keep-offers>
    </div>
  </div>   -->
</div>